export const environment = {
  production: false,
  deployMode: 'saas',
  customer: null,
  customerCategory: null
};
